import { AppleButton, FacebookButton, GoogleButton } from 'components';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Container, IconsWrapper, Label } from './styled';

type Provider = 'google' | 'apple' | 'facebook';

interface SocialContainerProps {
  style?: React.CSSProperties;
  disabled?: boolean;
  onAuthStart?: () => void;
  highlightProviders?: Provider[];
  iconOnly?: boolean;
}

const SocialContainer = ({
  style,
  disabled,
  onAuthStart,
  highlightProviders = [],
  iconOnly,
}: SocialContainerProps) => {
  const { t } = useTranslation();
  const [activeProvider, setActiveProvider] = useState<Provider | null>(null);

  const handleStart = (provider: Provider) => {
    if (disabled) return;
    setActiveProvider(provider);
    onAuthStart?.();
  };

  return (
    <Container style={style}>
      <Label>{t('auth.signInWith') || 'sign in with'}</Label>
      {iconOnly ? (
        <IconsWrapper>
          <GoogleButton
            disabled={
              disabled ||
              (activeProvider !== null && activeProvider !== 'google')
            }
            onAuthStart={() => handleStart('google')}
            forceLoading={activeProvider === 'google'}
            highlighted={highlightProviders.includes('google')}
            iconOnly
          />
          <AppleButton
            disabled={
              disabled ||
              (activeProvider !== null && activeProvider !== 'apple')
            }
            onAuthStart={() => handleStart('apple')}
            forceLoading={activeProvider === 'apple'}
            highlighted={highlightProviders.includes('apple')}
            iconOnly
          />
          <FacebookButton
            disabled={
              disabled ||
              (activeProvider !== null && activeProvider !== 'facebook')
            }
            onAuthStart={() => handleStart('facebook')}
            forceLoading={activeProvider === 'facebook'}
            highlighted={highlightProviders.includes('facebook')}
            iconOnly
          />
        </IconsWrapper>
      ) : (
        <>
          <GoogleButton
            style={{ width: '100%' }}
            disabled={
              disabled ||
              (activeProvider !== null && activeProvider !== 'google')
            }
            onAuthStart={() => handleStart('google')}
            forceLoading={activeProvider === 'google'}
            highlighted={highlightProviders.includes('google')}
          />
          <AppleButton
            style={{ width: '100%' }}
            disabled={
              disabled ||
              (activeProvider !== null && activeProvider !== 'apple')
            }
            onAuthStart={() => handleStart('apple')}
            forceLoading={activeProvider === 'apple'}
            highlighted={highlightProviders.includes('apple')}
          />
          <FacebookButton
            style={{ width: '100%' }}
            disabled={
              disabled ||
              (activeProvider !== null && activeProvider !== 'facebook')
            }
            onAuthStart={() => handleStart('facebook')}
            forceLoading={activeProvider === 'facebook'}
            highlighted={highlightProviders.includes('facebook')}
          />
        </>
      )}
    </Container>
  );
};

export default SocialContainer;
